import React, { PureComponent } from "react";
import { connect } from "react-redux";
import moment from "moment";

import { CYCLE_ITEMS } from "Config";
import { setCycleCombination } from "Actions";
import {
  initTimeSheetTree,
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  setFilterClientGroup,
  setFilterClient,
  setFilterPeriods,
  setFilterPeriodUnit,
  setFilterCollaborators,
  setFilterTaskCategory
} from "Actions";
import TimeSheetTree from "./TimeSheetTree";
import { renderPeriodsByRangeDateAndPeriodUnit, parsePreference } from "Utils";
import {
  fetchTimeSheet,
  fetchNonCategorizedTaskTypeCount,
  fetchCollaborator
} from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";

class TimeSheetPage extends PureComponent {
  constructor(props) {
    super(props);
    console.log("this.props.match.params====");
    console.log(this.props.match.params);
    let { uen, id, name, startDate, endDate } = this.props.match.params;

    this.state = {
      organizationUen: uen,
      collaboratorId: id,
      collaboratorName: name,
      startDate: startDate ? moment(startDate) : null,
      endDate: endDate ? moment(endDate) : null
    };
  }

  componentDidMount() {
    const {
      dispatch,
      subMenuDirection,
      currentOrganization,
      user
    } = this.props;

    const preferences =
      currentOrganization["authorisation"] &&
      currentOrganization["authorisation"].preferences;

    dispatch(
      fetchCollaborator(
        user.id,
        user.uid,
        user.adminisId ? user.adminisId.split(":")[1] : null
      )
    );

    dispatch(setCurrentNavPage("TIME_SHEET_PAGE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));
    let params = this.props.match ? this.props.match.params : {};
    let { uen, id, name, startDate, endDate } = params;

    let parsedStartDate = moment(startDate, moment.ISO_8601, true);
    let parsedEndDate = moment(endDate, moment.ISO_8601, true);
    this.setState({
      organizationUen: uen,
      collaboratorId: id || null,
      collaboratorName: name || null,
      startDate: parsedStartDate.isValid()
        ? parsedStartDate
        : moment().startOf("year"),
      endDate: parsedEndDate.isValid() ? parsedEndDate : moment()
    });

    let combination = CYCLE_ITEMS.map(k => ({
      id: k,
      visible: true
    }));

    dispatch(initTimeSheetTree());
    dispatch(setCycleCombination(combination));

    if (id) {
      dispatch(
        setFilterCollaborators([
          {
            value: id,
            label: this.state.collaboratorName,
            color: "#000000"
          }
        ])
      );

      dispatch(setFilterPeriodUnit("date"));
      dispatch(
        setFilterPeriods(
          renderPeriodsByRangeDateAndPeriodUnit(
            this.state.startDate,
            this.state.endDate,
            "date"
          )
        )
      );
    } else {
      this.props.dispatch(
        setFilterPeriods(
          renderPeriodsByRangeDateAndPeriodUnit(
            moment().startOf("year"),
            moment(),
            "year"
          )
        )
      );
    }
    if (parsePreference(preferences.prestations).allowViewDataBy === 1) {
      dispatch(fetchTimeSheet());
      dispatch(fetchNonCategorizedTaskTypeCount());
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, currentOrganization, collaborator } = this.props;
    if (prevProps.collaborator !== collaborator) {
      const preferences =
        currentOrganization["authorisation"] &&
        currentOrganization["authorisation"].preferences;

      dispatch(
        setFilterCollaborators(
          [10, 100, 101, 110].includes(
            parsePreference(preferences.prestations).allowViewDataBy
          ) && collaborator
            ? [
                {
                  label: collaborator.name,
                  value: collaborator.id,
                  partner: collaborator.partner.value,
                  color: "#000000",
                  isActif: true
                }
              ]
            : []
        )
      );
      dispatch(fetchTimeSheet());
      dispatch(fetchNonCategorizedTaskTypeCount());
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
    dispatch(setFilterCollaborators([]));
    dispatch(setFilterClient([]));
    dispatch(setFilterClientGroup([]));
    dispatch(setFilterTaskCategory([]));
  }

  render() {
    return (
      <div className={`page-content`}>
        <TimeSheetTree uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  organization: state.timeSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization,
  collaborator: state.collaborator.collaborator,
  user: state.auth.user
});

export default connect(mapStateToProps)(TimeSheetPage);



// WEBPACK FOOTER //
// ./src/components/TimeSheet/TimeSheetPage.js